import { useParams } from 'react-router';

import { TemplateEditorContent } from '../components/TemplateEditorContent';

export const TemplateEditorPage: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  return <TemplateEditorContent templateId={id ?? null} variant="page" />;
};
